export default [
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: () => import('@login/pages/index.vue'),
  },
  {
    path: '/register',
    name: 'register',
    meta: { title: '注册' },
    component: () => import('@login/pages/register/stepOne.vue'),
  },
  {
    path: '/register/stepTwo',
    name: 'register-Two',
    meta: { title: '注册' },
    component: () => import('@login/pages/register/stepTwo.vue'),
  },
  {
    path: '/register/stepThree',
    name: 'register-Three',
    meta: { title: '注册' },
    component: () => import('@login/pages/register/stepThree.vue'),
  },
  {
    path: '/forget',
    name: 'forget',
    meta: { title: '重置密码' },
    component: () => import('@login/pages/forget/stepOne.vue'),
  },
  {
    path: '/forget/stepTwo',
    name: 'forget-Two',
    meta: { title: '重置密码' },
    component: () => import('@login/pages/forget/stepTwo.vue'),
  },
  {
    path: '/forget/stepThree',
    name: 'forget-Three',
    meta: { title: '重置密码' },
    component: () => import('@login/pages/forget/stepThree.vue'),
  },
];
